import React from "react";
import "antd/dist/antd.css";
import "./CitySelect.scss";
import { Cascader } from "antd";
import region from "../../assets/region.json";

const regionOps = region.map((item) => {
  const districtsObj = item.districts.map((element) => {
    return {
      value: element,
      label: element,
    };
  });
  return {
    value: item.name,
    label: item.name,
    children: districtsObj,
  };
});

function CitySelect({ getChildValue }) {
  function sendValue(value) {
    getChildValue(value);
  }
  return (
    <div className="citySelect__container">
      <Cascader
        style={{ width: 180 }}
        placeholder="縣市區域"
        options={regionOps}
        defaultValue={["台北市", "中正區"]}
        onChange={sendValue}
      />
      ,
    </div>
  );
}

export default CitySelect;
